import { Box, Typography } from "@mui/material";
import styles from "./Profile.module.css";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useState } from "react";
import { useSelector } from "react-redux";

const CandidateListCard = ({ candidate, handleOnClickJobID }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location) || [];
  const skillData = useSelector((state) => state.skill.data);

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };

  const matchingSkills2nd = (row) => {
    // Filter skills based on matching IDs in the row
    const allSkills = skillData?.locations?.filter((skill) =>
      row?.includes(skill.id)
    );

    // Extract only the names of the matching skills
    const skillNames = allSkills?.map((skill) => skill.name);

    return skillNames?.join(", ");
  };

  const matchingSkills = (row) => {

    // Filter skills based on matching IDs in the row
    const allSkills = skillData?.locations?.filter((skill) =>
      row?.includes(skill.id)
    );

    // Extract only the names of the matching skills
    const skillNames = allSkills?.map((skill) => skill.name);

    const displayedSkills =
      skillNames?.length > 2
        ? `${skillNames.slice(0, 2).join(", ")}...`
        : skillNames?.join(", ");


    return displayedSkills;

    // return skillNames?.join(", ");
  };
  return (
    <Box className={styles.candidateList}>
      <Box>
        <Typography>
          <b>
            {candidate?.full_name} -{" "}
            {getWorkAuthorization(candidate?.work_authorization)}
          </b>
        </Typography>
        <Typography>
          <b>
            {candidate?.current_job_title}, Exp {candidate?.total_experience}{" "}
            Years
          </b>
        </Typography>
        <Typography>
          <b>
            {getLocationById(candidate?.current_location)},
            {getPreferLocationNames(candidate?.prefer_location)}
          </b>
        </Typography>
        <Typography>
          <b>
            {" "}
            {candidate?.p_tax_team?.includes("full_Time")
              ? `Salary $${candidate?.rate}`
              : `Rate $${candidate?.rate}`}{" "}
            {candidate?.p_tax_team?.includes("full_Time") ? "Yearly" : "Hourly"}
          </b>
        </Typography>
        <Typography sx={{ display: "flex" }}>
          {" "}
          Excellency in skills:{" "}
          <span
            style={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: "5px",
            }}
          >
            {isExpanded ? (
              <b>{matchingSkills2nd(candidate?.skills)}</b>
            ) : (
              <b>{matchingSkills(candidate?.skills)}</b>
            )}
          </span>
          <span style={{ marginLeft: "10px" }} onClick={handleExpandClick}>
            {isExpanded ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </span>
        </Typography>
      </Box>
      <span>
        <Typography>
          Credit Earned{" "}
          <b style={{ fontSize: "18px" }}>{candidate?.total_credit_earned}</b>
        </Typography>
        <button onClick={() => handleOnClickJobID(candidate)}>
          View Details
        </button>
      </span>
    </Box>
  );
};

export default CandidateListCard;
